import { useSelector } from "react-redux";
import { IonCard, IonItem, IonLabel, IonText } from "@ionic/react";
import { selectUserRoles } from "../../../store/locationShow/selectors/selectUserRoles";
export const UserRolesSection: React.FC = () => {
  const userRoles = useSelector(selectUserRoles);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Usuarios</IonText>
      </h2>
      <IonCard>
        {userRoles.length === 0 && (
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se han encontrado usuarios</IonText>
            </IonLabel>
          </IonItem>
        )}
        {userRoles.map((userRoleItem) => (
          <IonItem lines="none" key={userRoleItem.id}>
            <IonLabel>
              <h2 style={{ fontWeight: 500 }}>{userRoleItem.user?.name}</h2>
              <h3>{userRoleItem.role?.name}</h3>
              <p>
                {userRoleItem.periodStart} - {userRoleItem.periodEnd}
              </p>
            </IonLabel>
          </IonItem>
        ))}
      </IonCard>
    </>
  );
};
